import { render, staticRenderFns } from "./ChartLegendItem.vue?vue&type=template&id=2d563c52&scoped=true&"
import script from "./ChartLegendItem.vue?vue&type=script&lang=js&"
export * from "./ChartLegendItem.vue?vue&type=script&lang=js&"
import style0 from "./ChartLegendItem.vue?vue&type=style&index=0&id=2d563c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d563c52",
  null
  
)

export default component.exports